// react and js
import { Link as RouterLink } from "react-router-dom";
import { React } from "react";
import { useTranslation } from "react-i18next";

// mui
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Box, AppBar, Typography, Grid } from "@mui/material";

// components
import LanguageSelector from "../components/LanguageSelector";

// hooks
import defines from "../hooks/defines";

// i18n
import { localizeExternalUrl } from "../i18n/languages";

// layouts

// pages

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function PublicHeader() {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const websiteUrl = localizeExternalUrl(
    process.env.REACT_APP_URL_FRONTEND_WEBSITE,
    i18n.language
  );

  return (
    <AppBar
      sx={{
        background: "#F2F2F2",
        boxShadow: "0px 0px 2px rgba(0,0,0,0.5)",
        minHeight: isDesktop
          ? defines.headerHeightDesktop
          : defines.headerHeightMobile,
        maxHeight: isDesktop
          ? defines.headerHeightDesktop
          : defines.headerHeightMobile,
      }}
    >
      <Grid
        container
        sx={{
          position: "relative",
          justifyContent: "space-between",
          alignItems: "center",
          justifyItems: "center",
          minHeight: isDesktop
            ? defines.headerHeightDesktop
            : defines.headerHeightMobile,
          maxHeight: isDesktop
            ? defines.headerHeightDesktop
            : defines.headerHeightMobile,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <RouterLink
            to={websiteUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
            }}
          >
            {isDesktop ? (
              <Box
                component="img"
                src={process.env.REACT_APP_PATH_ICON_SCALEABLE}
                sx={{
                  marginTop: "-1px",
                  marginLeft: "22px",
                  width: "38px",
                  height: "38px",
                }}
              />
            ) : (
              <Box
                component="img"
                src={process.env.REACT_APP_PATH_ICON_SCALEABLE}
                sx={{
                  marginTop: "-2px",
                  marginLeft: "16px",
                  width: "38px",
                  height: "38px",
                }}
              />
            )}

            <Typography
              sx={{
                marginLeft: "12px",
                fontSize: "22px",
                fontWeight: 700,
                letterSpacing: 0.15,
                color: "#2E2E2E",
                whiteSpace: "nowrap",
              }}
            >
              {process.env.REACT_APP_NAME_BIZ}
            </Typography>
          </RouterLink>
        </Box>

        <Box
          sx={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            pointerEvents: "none",
          }}
        >
          {isDesktop && (
            <Typography variant="topbar" sx={{ whiteSpace: "nowrap" }}>
              {t("layout.topbarTitle")}
            </Typography>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginRight: isDesktop ? "22px" : "16px",
          }}
        >
          <LanguageSelector />
        </Box>
      </Grid>
    </AppBar>
  );
}
